import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ImageCard from '../../image-card'

import './index.styl'

const Philosophy = ({ screen, pageData }) => {
  const { 
    first_block, 
    second_block, 
    image1, 
    image2,
    factory_image1,
    factory_image2,
    factory_image3,
    factory_image4,
    stamp,
  } = pageData

  const { t } =  useTranslation()

  return (
    <div className="philosophy">
      <ImageCard
        className="philosophy__cover"
        imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${image1}`}
        mode={screen === 'sm' || screen === 'xs' ? 'background' : 'image'}
      />
      <div className="philosophy__introduction">
        <h2 className="philosophy__title">Hwa Fong Rubber Group</h2>
        <div className="philosophy__paragraph philosophy__introduction-paragraph">{first_block}</div>
      </div>
      <div className="philosophy__content-wrap">
        <div className="philosophy__content">
          {second_block
            .split(/\n/)
            .filter(d => d.length > 0)
            .map((text, i) => (
              <div key={i} className="philosophy__paragraph">
                {text}
              </div>
            ))}
        </div>
        <ImageCard
          className="philosophy__intro-img"
          imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${image2}`}
        />
      </div>
      {
        (factory_image1 && factory_image2 && factory_image3 && factory_image4) && (
          <div className="philosophy__factory-wrap">
            <div className="philosophy__factory-main-col padding-4">
              <ImageCard
                caption={t('philosophy.factory.thailand')}
                className="philosophy__factory-img"
                mode = "background"
                imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${factory_image1}`}
              />
            </div>
            <div className="philosophy__factory-main-col philosophy__factory-main-col-flex">
              <div className="row-10 flex-wrap height-5">
                <div className="row-5 align-self-stretch padding-4">
                  <ImageCard
                    caption={t('philosophy.factory.taiwan')}
                    className="philosophy__factory-img"
                    mode = "background"
                    imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${factory_image2}`}
                  />
                </div>
                <div className="row-5 align-self-stretch padding-4">
                  <ImageCard
                    caption={t('philosophy.factory.china')}
                    className="philosophy__factory-img"
                    mode = "background"
                    imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${factory_image3}`}
                  />
                </div>
              </div>
              <div className="row-10 height-5 padding-4">
                <ImageCard
                  caption={t('philosophy.factory.usa')}
                  className="philosophy__factory-img"
                  mode = "background"
                  imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${factory_image4}`}
                />
              </div>
            </div>
          </div>
        )
      }
      {
        <ImageCard
          className="philosophy__stamp-img"
          imgUrl={`https://www.duro.com.tw:8088/api/v1.0/image/${stamp}`}
        />
      }
    </div>
  )
}

Philosophy.propTypes = {}

export default Philosophy
